import axios from 'axios';

import { DataError } from './data-error';

import {Sitters} from './sitters';

/**
 * class responsibility to deal with data
 */
export class SittersData extends Sitters{
    constructor(config) {
        super(config);
        this.Sitters = [];
        this.relatedSitters = [];
        this.errors = [];
    }

    /**
     * استرجاع بيانات الحاضنات عن طريق خدمة 
     * <domain>/streetVendorsAPI/api/sitters
     * @param {*} options 
     * @returns 
     */
    async loadSitters(options) {
        try {
            this.Sitters = [];
            let sitterrespones = await this.sittersRequest(options);
            if (this.validateRespones(sitterrespones)) {
                if (this.notEmptyRespones(sitterrespones)) {
                    this.Sitters.push(sitterrespones.data.data.result);
                    return "Ok";
                }
                return null;
            }
        } catch (error) {
            throw error;
        }
    }

    loadRelatedSitter(config) {

    }

    sitterByGUID(id) {

    }

    validateRespones(respones) {
        if (respones && respones.status == 200) {
            return true;
        }
        return false;
    }

    notEmptyRespones(respones) {
        if (respones.data.data.responseCode != 2) {
            return true;
        }
        return false;
    }

    async sittersRequest(options) {
        try {
            let sitterApiUrl = `${options.apiUrl}/${options.cities}/${options.portType}?distrect=${options.distrect}&street=${options.street}`
            let url = this.checkSitterApiUrl(sitterApiUrl);
            return axios.post(url, {
                "incubatorToken": options.clientId
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).catch(e => {
                this.errors.push(new DataError('sitterRequestInvalid', e))
            })
        } catch (error) {
            throw error;
        }
    }

    checkSitterApiUrl(url) {
        if (url.includes(undefined)) {
            return url.replaceAll(undefined, '');
        }
        return url;
    }

    isSitterPortPaths(config) {
        if (config.hasOwnProperty('sitterPortPaths')) {
            if (config.sitterPortPaths.length > 0) {
                return true;
            }
        }
        return false;
    }

    isSellingPortType(config) {
        if (config.hasOwnProperty('sellingPortType')) {
            if (config.sellingPortType == true) {
                return true;
            }
        }
        return false;
    }

}

